import { render, staticRenderFns } from "./AddWebHostingWebsiteAliasModal.vue?vue&type=template&id=69dc03b7&scoped=true&"
import script from "./AddWebHostingWebsiteAliasModal.vue?vue&type=script&lang=js&"
export * from "./AddWebHostingWebsiteAliasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc03b7",
  null
  
)

export default component.exports